import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enLocales from "./en.json";
import frLocales from "./fr.json";
import esLocales from "./es.json";
import ptLocales from "./pt.json";
import deLocales from "./de.json";
import jaLocales from "./ja.json";

const SUPPORTED_LANGS = ["en", "fr", "es", "pt", "de", "ja"];

const getInitialLanguage = () => {
  try {
    if (typeof window !== "undefined") {
      const userChoice = localStorage.getItem("user_selected_lang");
      if (userChoice) {
        const code = userChoice.slice(0, 2).toLowerCase();
        if (SUPPORTED_LANGS.includes(code)) return code;
      }
      const browserLang = (navigator.language || navigator.userLanguage || "").slice(0, 2).toLowerCase();
      if (SUPPORTED_LANGS.includes(browserLang)) return browserLang;
    }
  } catch (e) {}
  return "en";
};

i18n.use(initReactI18next).init({
  resources: {
    en: enLocales,
    fr: frLocales,
    es: esLocales,
    pt: ptLocales,
    de: deLocales,
    ja: jaLocales,
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
